import { render, staticRenderFns } from "./AdminBtns.vue?vue&type=template&id=1b6f7489&"
import script from "./AdminBtns.vue?vue&type=script&lang=js&"
export * from "./AdminBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports